exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-adiciona{\n\t\ttext-align: center;\n\t\tfont-size: 13px;\n\t\tline-height: 1.428571429;\n\t\tborder-radius: 10px;\n\t\t\n    padding-top: 4px;\n    padding-bottom: 4px;\n    padding-left: 8px;\n    padding-right: 8px;\n}\n.cor{\n\t\tcolor: currentColor!important;\n}\n.descricao {\n    \tfont-size: 14px !important;\n\t \tpadding-right: 10px !important;\n}\n", ""]);

// exports
